import { createSlice } from "@reduxjs/toolkit";

const towerSlice = createSlice({
  name: "tower",
  initialState: {
    towerType: "",
    formData: {},
  },
  reducers: {
    setTowerType: (state, action) => {
      state.towerType = action.payload;
    },
    updateFormData: (state, action) => {
      state.formData = {
        ...state.formData,
        ...action.payload,
      };
    },
  },
});

export const { setTowerType, updateFormData } = towerSlice.actions;
export const selectTowerType = (state) => state.tower.towerType;
export default towerSlice.reducer;
